module.exports = __webpack_public_path__ + "static/media/animateIcon.db468641.svg";